import React from "react";
import { Link, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";

const Unauthorized: React.FC = () => {
    const location = useLocation();
    const isStaffPage = location.pathname.includes("staff");

    return (
        <div className="">
            {isStaffPage ? (
                <div className="pt-5 pl-5 items-center">
                    <h1 className="text-2xl font-bold text-red-500">Unauthorized</h1>
                    <p className="text-lg mt-4">You do not have permission to access this page.</p>
                </div>
            ) : (
                <>
                    <Navbar />
                    <div className="w-screen h-screen pt-20 flex flex-col items-center">
                        <h1 className="text-4xl font-bold text-red-500">Unauthorized</h1>
                        <p className="text-lg mt-4">You do not have permission to access this page.</p>
                        <Link to="/" className="mt-6 text-blue-500 hover:underline">
                            Go back to Home
                        </Link>
                    </div>
                </>
            )}
        </div>
    );
};

export default Unauthorized;